export default "__VITE_ASSET__BlqDXL7T__"